import { motion } from 'framer-motion';
import { Star } from '@phosphor-icons/react';

const reviews = [
  { author: 'Anusha Govindan',   rating: 5, time: '24 hours ago', color: '#EA4335',
    text: 'Working at Vista Tech was a great experience. I was involved in hands-on tasks and practical work, which helped me gain real-time exposure. The guidance and support from the mentors made learning easy and effective.' },
  { author: 'Vasanth Kumar',     rating: 5, time: '24 hours ago', color: '#4285F4',
    text: 'My experience working at Vista Tech was very good. I gained practical knowledge, worked on real-world projects, and learned professional work culture. The mentors provided continuous guidance. I am thankful for this opportunity.' },
  { author: 'Rajeshwari S',      rating: 5, time: '2 weeks ago',  color: '#34A853',
    text: "Vista Tech transformed my skills! I joined without any coding background, and now I'm developing full-stack apps confidently. Projects are real-world oriented — not just theory. Totally worth it!" },
  { author: 'Naveen Kumar',      rating: 5, time: '10 weeks ago', color: '#9C27B0',
    text: "I'm working as a Technical Trainer at Vista Tech, and it's been an amazing experience. We focus on practical, hands-on training to help students understand real-world applications." },
  { author: 'Pooja Sivakumar',   rating: 5, time: '22 weeks ago', color: '#FF6535',
    text: 'I completed my Java Full Stack Development course here, and it was an amazing experience. Thanks to their guidance and placement support, I got placed in a good company. Totally recommend this institute!' },
  { author: 'Viveka D',          rating: 5, time: '22 weeks ago', color: '#00897B',
    text: 'I recently completed my Java Full Stack Development course. The course covered Java, Spring Boot, HTML, CSS, JavaScript, and MySQL. This gave me strong technical knowledge and confidence to build complete web applications.' },
];

const GoogleG = ({ size = 28 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 48 48">
    <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
    <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
    <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
    <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.18 1.48-4.93 2.31-8.16 2.31-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
  </svg>
);

interface Props {
  background?: string;
}

const GoogleReviewsSection = ({ background = '#f8f7ff' }: Props) => (
  <section style={{ padding: '80px 1.5rem', background }}>
    <div style={{ maxWidth: '1100px', margin: '0 auto' }}>

      {/* Header */}
      <motion.div
        initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }} transition={{ duration: 0.6 }}
        style={{ textAlign: 'center', marginBottom: '52px' }}
      >
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '16px', marginBottom: '20px', flexWrap: 'wrap' }}>
          <GoogleG size={36} />
          <div>
            <div style={{ fontSize: '2.6rem', fontWeight: '900', color: '#2b2240', lineHeight: 1 }}>4.8</div>
            <div style={{ display: 'flex', gap: '3px', marginTop: '4px' }}>
              {[0,1,2,3,4].map(i => <Star key={i} size={18} weight="fill" color="#FBBC05" />)}
            </div>
          </div>
          <div style={{ borderLeft: '1px solid rgba(43,34,64,0.12)', paddingLeft: '16px' }}>
            <div style={{ fontSize: '0.9rem', fontWeight: '700', color: '#2b2240' }}>Google Reviews</div>
            <div style={{ fontSize: '0.78rem', color: '#9ca3af', marginTop: '2px' }}>11+ verified reviews</div>
          </div>
        </div>
        <h2 style={{ fontSize: 'clamp(1.5rem, 3vw, 2.2rem)', fontWeight: '800', color: '#2b2240', marginBottom: '10px' }}>
          What Our Students Say on <span style={{ color: '#4285F4' }}>Google</span>
        </h2>
        <p style={{ color: '#6b7280', fontSize: '1rem' }}>Real reviews from real students — verified on Google</p>
      </motion.div>

      {/* Cards */}
      <div className="grid-3col" style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: '18px', marginBottom: '36px' }}>
        {reviews.map((r, i) => {
          const initials = r.author.split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2);
          return (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }} transition={{ delay: i * 0.08 }}
              whileHover={{ y: -4, boxShadow: '0 16px 40px rgba(43,34,64,0.1)' }}
              style={{
                background: 'white', borderRadius: '18px', padding: '22px',
                border: '1px solid rgba(43,34,64,0.07)',
                boxShadow: '0 4px 18px rgba(43,34,64,0.06)', position: 'relative',
              }}
            >
              {/* Watermark G */}
              <div style={{ position: 'absolute', top: '14px', right: '16px', opacity: 0.1 }}>
                <GoogleG size={24} />
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '12px' }}>
                <div style={{ width: '40px', height: '40px', borderRadius: '50%', background: r.color, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontWeight: '800', fontSize: '0.95rem', flexShrink: 0 }}>
                  {initials}
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: '700', color: '#2b2240', fontSize: '0.9rem' }}>{r.author}</div>
                  <div style={{ display: 'flex', gap: '2px', marginTop: '2px' }}>
                    {[...Array(r.rating)].map((_, j) => <Star key={j} size={12} weight="fill" color="#FBBC05" />)}
                  </div>
                </div>
                <div style={{ fontSize: '0.7rem', color: '#9ca3af', whiteSpace: 'nowrap' }}>{r.time}</div>
              </div>
              <p style={{ color: '#4b5563', fontSize: '0.84rem', lineHeight: 1.7, margin: 0 }}>"{r.text}"</p>
            </motion.div>
          );
        })}
      </div>

      {/* CTA */}
      <div style={{ textAlign: 'center' }}>
        <a
          href="https://maps.app.goo.gl/sjz7bY3cbBdHQ1t3A"
          target="_blank" rel="noopener noreferrer"
          style={{
            display: 'inline-flex', alignItems: 'center', gap: '10px',
            padding: '12px 26px', borderRadius: '12px',
            background: 'white', border: '1.5px solid rgba(43,34,64,0.15)',
            color: '#2b2240', fontWeight: '700', fontSize: '0.88rem',
            textDecoration: 'none', boxShadow: '0 4px 14px rgba(43,34,64,0.08)',
          }}
        >
          <GoogleG size={18} /> See All Reviews on Google
        </a>
      </div>
    </div>
  </section>
);

export default GoogleReviewsSection;
